// XfLineupLab.jsx
import NascarLineupLab from "./NascarLineupLab";

export default function XfLineupLab() {
  return <NascarLineupLab series="xfinity" />;
}